import { type CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';

import { type ScrollOffsetAdapter } from './scroll-offset-adapter';

export class WindowScrollOffsetAdapter implements ScrollOffsetAdapter {
  private readonly document = inject<Document>(DOCUMENT);

  private lastValue = 0;

  /**
   * If cdk-global-scrollblock class is present (meaning a dialog with scroll block strategy is open)
   * returns last reading. Otherwise, returns scroll offset measured by CdkVirtualScrollViewport
   * @param viewport
   */
  measureScrollOffset(viewport: CdkVirtualScrollViewport): number {
    const htmlElement = this.document.documentElement;
    const blocked = htmlElement.classList.contains('cdk-global-scrollblock');

    if (blocked) {
      return this.lastValue;
    }

    this.lastValue = Math.max(0, viewport.measureScrollOffset());
    return this.lastValue;
  }
}
